var map = {
	"./Human_symbol_0.png": "ab05",
	"./Human_symbol_1.png": "b341",
	"./Human_symbol_2.png": "cd81",
	"./Human_symbol_3.png": "03d8",
	"./Human_symbol_4.png": "e47c",
	"./Human_symbol_5.png": "200b",
	"./Human_symbol_6.png": "b4b8",
	"./Human_symbol_7.png": "ca76",
	"./Human_symbol_8.png": "0f62",
	"./Human_symbol_9.png": "f041"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd34";